import { render } from "./ModalNominal.vue?vue&type=template&id=05cb2088&ts=true"
import script from "./ModalNominal.vue?vue&type=script&lang=ts"
export * from "./ModalNominal.vue?vue&type=script&lang=ts"

import "./ModalNominal.vue?vue&type=style&index=0&id=05cb2088&lang=css"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__